module.exports = __webpack_public_path__ + "static/media/edit.4594120d.webp";